const Resources = {
    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Reports",
            href: "/reports",
            arrow: "<span class='slash'>/</span>",
        },
    ],
    headers_break_table: [
        {
          title: 'Break',
          dataKey: 'description'
        },
        {
          title: 'Time',
          dataKey: 'format_time'
        },
        {
          title: 'Length',
          dataKey: 'length'
        }
    ],
    assignment_time_square_footage_table: [
        {
            text: '#',
            value: 'number_assigment',
            report_value: 'number_assigment',
            show: true,
            style: "width: 10%"
        },
        {
            text: 'Description',
            value: 'description',
            report_value: 'description',
            show: true,
            style: "width: 47%"
        },
        {
            text: 'Sq. Ft',
            value: 'sq_ft_today',
            report_value: 'sq_ft_today',
            show: true,
            style: "width: 15%;"
        },
        {
            text: 'Assignment Minutes',
            value: 'minutes_today',
            report_value: 'minutes_today',
            show: true,
            style: "width: 15%;"
        },
        {
            text: 'Sq. Ft/Worked Hours',
            value: 'sq_ft_worked_hours',
            report_value: 'sq_ft_worked_hours',
            show: true,
            style: "width: 20%;"
        }
    ],
    assignment_info_by_shift_table: [
        {
            text: '#',
            value: 'number_assigment',
            report_value: 'number_assigment',
            show: true,
            style: "width: 5%"
        },
        {
            text: 'Description',
            value: 'description',
            report_value: 'description',
            show: true,
            style: "width: 47%"
        },
        {
            text: 'Associate',
            value: 'associate',
            report_value: 'associate',
            show: true,
            style: "width: 27%"
        },
        {
            text: 'Freq',
            value: 'days_per_week',
            report_value: 'days_per_week',
            show: true,
            style: "width: 7%;"
        },
        {
            text: 'Time Avail',
            value: 'available_minutes',
            report_value: 'available_minutes',
            show: true,
            style: "width: 14%;"
        },
        {
            text: 'Minutes',
            value: 'minutes_today',
            report_value: 'minutes_today',
            show: true,
            style: "width: 10%;"
        },
        {
            text: 'FTEs',
            value: 'ftes',
            report_value: 'ftes',
            show: true,
            style: "width: 10%;"
        }
    ],

    assignment_time_utilization_table: [
        {
            text: '#',
            value: 'number_assigment',
            report_value: 'number_assigment',
            show: true,
            style: "width: 5%"
        },
        {
            text: 'Description',
            value: 'description',
            report_value: 'description',
            show: true,
            style: "width: 47%"
        },
        {
            text: 'Associate',
            value: 'associate',
            report_value: 'associate',
            show: true,
            style: "width: 20%"
        },
        {
            text: 'FTE',
            value: 'ftes',
            report_value: 'ftes',
            show: true,
            style: "width: 5%;"
        },
        {
            text: 'Avg. Assignment Time',
            value: 'avg_assignment_time',
            report_value: 'avg_assignment_time',
            show: true,
            style: "width: 19%;"
        },
        {
            text: 'Avg SqFt',
            value: 'avg_sq_ft',
            report_value: 'avg_sq_ft',
            show: true,
            style: "width: 10%;"
        },
        {
            text: '% Time Utilization',
            value: 'time_utilization',
            report_value: 'time_utilization',
            show: true,
            style: "width: 14%;"
        }
    ],

    assignment_duties_with_clean_code_table: [
        {
            text: 'Description',
            value: 'description',
            report_value: 'description',
            show: true,
            style: "width: 50%"
        },
        {
            text: 'Task',
            value: 'task',
            report_value: 'task',
            show: true,
            style: "width: 15%"
        },
        {
            text: 'Sun',
            value: 'sunday',
            report_value: 'sunday',
            show: true,
            style: "width: 5%;",
            type: 'boolean'

        },
        {
            text: 'Mon',
            value: 'monday',
            report_value: 'monday',
            show: true,
            style: "width: 5%;",
            type: 'boolean'
        },
        {
            text: 'Tue',
            value: 'tuesday',
            report_value: 'tuesday',
            show: true,
            style: "width: 5%;",
            type: 'boolean'
        },
        {
            text: 'Wed',
            value: 'wednesday',
            report_value: 'wednesday',
            show: true,
            style: "width: 5%;",
            type: 'boolean'
        },
        {
            text: 'Thu',
            value: 'thursday',
            report_value: 'thursday',
            show: true,
            style: "width: 5%;",
            type: 'boolean'
        },
        {
            text: 'Fri',
            value: 'friday',
            report_value: 'friday',
            show: true,
            style: "width: 5%;",
            type: 'boolean'
        },
        {
            text: 'Sat',
            value: 'saturday',
            report_value: 'saturday',
            show: true,
            style: "width: 5%;",
            type: 'boolean'
        }
    ],

    assignment_weekly_minutes_table: [
        {
            text: 'Assignment #',
            value: 'number_assigment',
            report_value: 'number_assigment',
            show: true,
            style: "width: 6%"
        },
        {
            text: 'Description',
            value: 'description',
            report_value: 'description',
            show: true,
            style: "width: 25%"
        },
        {
            text: 'Sun',
            value: 'sunday_minutes',
            report_value: 'sunday_minutes',
            show: true,
            style: "width: 5%;"

        },
        {
            text: 'Mon',
            value: 'monday_minutes',
            report_value: 'monday_minutes',
            show: true,
            style: "width: 5%;"
        },
        {
            text: 'Tue',
            value: 'tuesday_minutes',
            report_value: 'tuesday_minutes',
            show: true,
            style: "width: 5%;"
        },
        {
            text: 'Wed',
            value: 'wednesday_minutes',
            report_value: 'wednesday_minutes',
            show: true,
            style: "width: 5%;"
        },
        {
            text: 'Thu',
            value: 'thursday_minutes',
            report_value: 'thursday_minutes',
            show: true,
            style: "width: 5%;"
        },
        {
            text: 'Fri',
            value: 'friday_minutes',
            report_value: 'friday_minutes',
            show: true,
            style: "width: 5%;"
        },
        {
            text: 'Sat',
            value: 'saturday_minutes',
            report_value: 'saturday_minutes',
            show: true,
            style: "width: 5%;"
        }
    ],

    daily_assignment_rooms_table: [
        {
            text: 'Room',
            value: 'custom_description',
            report_value: 'custom_description',
            show: true,
            style: "width: 30%"
        },
        {
            text: 'Task',
            value: 'task',
            report_value: 'task',
            show: true,
            style: "width: 12%"
        },
        {
            text: 'Minutes',
            value: 'room_task_minutes',
            report_value: 'room_task_minutes',
            show: true,
            style: "width: 12%"
        },
        {
            text: 'Frequency',
            value: 'frequency',
            report_value: 'frequency',
            show: true,
            style: "width: 12%;"
        },
        {
            text: 'Days Assigned',
            value: 'days_assigned',
            report_value: 'days_assigned',
            show: true,
            style: "width: 12%;"
        },
        {
            text: 'Sq. ft',
            value: 'sq_ft',
            report_value: 'sq_ft',
            show: true,
            style: "width: 12%;"
        },
    ],

    daily_assignment_rooms_table_2: [
        {
            text: 'Room',
            value: 'custom_description',
            report_value: 'custom_description',
            show: true,
            style: "width: 26%"
        },
        {
            text: 'Sq. ft',
            value: 'sq_ft',
            report_value: 'sq_ft',
            show: true,
            style: "width: 4%;"
        },
        {
            text: 'Task',
            value: 'task',
            report_value: 'task',
            show: true,
            style: "width: 7%"
        },
        {
            text: 'Freq',
            value: 'frequency',
            report_value: 'frequency',
            show: true,
            style: "width: 5%;"
        },
        {
            text: 'Units',
            value: 'fixtures_number',
            report_value: 'fixtures_number',
            show: true,
            style: "width: 6%;"
        },
        {
            text: 'Minutes',
            value: 'room_task_minutes',
            report_value: 'room_task_minutes',
            show: true,
            style: "width: 8%"
        },
    ],

    headers_break_table_abbreviated: [
        {
          title: 'START TIME',
          dataKey: 'format_time'
        },
        {
          title: 'DESCRIPTION',
          dataKey: 'description'
        },
    ],
    headers_step_codes_table: [
        {
          title: 'Step Descriptions',
          dataKey: 'name'
        },
    ],
    quick_report_supervisor_view: [
        {
            title: 'Start Time',
            dataKey: 'start_time'
        },
        {
            title: 'Description',
            dataKey: 'room'
        },
        {
            title: 'Task',
            dataKey: 'task'
        },
        {
            title: 'Minutes',
            dataKey: 'minutes'
        },
        {
            title: 'For Today Only',
            dataKey: 'for_today_only'
        },
        {
            title: 'Cleaning Steps',
            dataKey: 'step_codes'
        },  
    ],
    quick_report_associate_view: [
        {
            title: 'Start Time',
            dataKey: 'start_time'
        },
        {
            title: 'Description',
            dataKey: 'room'
        },
        {
            title: 'For Today Only',
            dataKey: 'for_today_only'
        },  
        {
            title: 'Cleaning Steps',
            dataKey: 'step_codes'
        },  
    ],
    quick_report_abbreviated_view: [
        {
            title: 'Description',
            dataKey: 'description_for_abbreviated',
            cellPadding: 2
        },
    ],
}

export default Resources;